import { render } from "./UpdatePlant.vue?vue&type=template&id=3e0e86c4"
import script from "./UpdatePlant.vue?vue&type=script&lang=js"
export * from "./UpdatePlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__